import { AlertModalTypeEnum, useAlertModal } from '.';

export function useDeleteAlert() {
  const { setAlertModalProps, showAlertModal, closeAlertModal } = useAlertModal();

  return ({
    onConfirm,
    title = 'Delete',
    text = 'Are you sure you want to delete this item?',
    content = 'This action cannot be undone.',
  }: {
        onConfirm: () => void | Promise<void>,
        title?: string
        text?: string
        content?: string
    }) => {
    setAlertModalProps({
      isOpen: true,
      title,
      contentHighlight: text,
      content,
      type: AlertModalTypeEnum.WARNING_IRREVERSIBLE,
      onClose: () => { closeAlertModal(); },
      onConfirm: () => {
        onConfirm();
        closeAlertModal();
      },
    });
    showAlertModal();
  };
}
